import React from 'react'
import SelectorContainer from '../../../containers/global/selector/SelectorContainer'
export default function Language({lang, langOption, onChangeLanguage }){
    return (        
            <SelectorContainer className="language" name="language.selector" options={langOption} selected={lang} onChangeSelect={onChangeLanguage} />

    )
}